var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-search",on:{"click":_vm.searchMyPosition}},[_c('span',[_vm._v("내 위치로 찾기")])])
}
var staticRenderFns = []

export { render, staticRenderFns }